import { render } from "./ExpiredMedicalCert.vue?vue&type=template&id=8c074388&scoped=true"
import script from "./ExpiredMedicalCert.vue?vue&type=script&lang=js"
export * from "./ExpiredMedicalCert.vue?vue&type=script&lang=js"

import "./ExpiredMedicalCert.vue?vue&type=style&index=0&id=8c074388&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c074388"]])

export default __exports__